import { render, staticRenderFns } from "./TopicTreeView.vue?vue&type=template&id=0a193276&scoped=true&"
import script from "./TopicTreeView.vue?vue&type=script&lang=js&"
export * from "./TopicTreeView.vue?vue&type=script&lang=js&"
import style0 from "./TopicTreeView.vue?vue&type=style&index=0&id=0a193276&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a193276",
  null
  
)

export default component.exports